import React, { Component } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOutAlt, faBars, faKey } from '@fortawesome/free-solid-svg-icons'

class Header extends Component {
    componentDidMount = () => {}

    sideBarControl = (e) => {e.preventDefault();
        let event = e.currentTarget.getAttribute('data-event')
        let sidebar = document.getElementById('aside-sidebar')
        let maincontent = document.getElementById('main-content')
        let mainheader = document.getElementById('main-header')
        var body = document.body
        if (event === 'close') {
            body.classList.add("sidebar-collapse");
            e.currentTarget.setAttribute('data-event', 'open')
            sidebar.classList.add('close-mobile-sidebar')
            sidebar.classList.remove('open-mobile-sidebar')
            maincontent.classList.add('close-mobile-content')
            maincontent.classList.remove('open-mobile-content')
            mainheader.classList.add('close-mobile-content')
            mainheader.classList.remove('open-mobile-content')
        } else {
            body.classList.remove("sidebar-collapse");
            e.currentTarget.setAttribute('data-event', 'close')
            sidebar.classList.add('open-mobile-sidebar')
            sidebar.classList.remove('close-mobile-sidebar')
            maincontent.classList.add('open-mobile-content')
            maincontent.classList.remove('close-mobile-content')
            mainheader.classList.add('open-mobile-content')
            mainheader.classList.remove('close-mobile-content')
        }
    }

    render() {
        return (
            <div>
                <nav className="main-header navbar navbar-expand navbar-white navbar-light" id="main-header">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link className="nav-link toggleSideMenu" id="toggleSideMenu" data-event="close" data-widget="pushmenu" to="#" role="button" onClick={ this.sideBarControl.bind(this)}><FontAwesomeIcon icon={ faBars } /></Link >
                        </li>
                        <li className="nav-item d-none d-sm-inline-block">
                            <NavLink to="/dashboard" className="nav-link">Home</NavLink >
                        </li>
                    </ul>
                   
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item d-none d-sm-inline-block">
                            <NavLink to="/changepass" className="nav-link"><FontAwesomeIcon icon={faKey} /> Change Password </NavLink >
                        </li>
                        <li className="nav-item d-none d-sm-inline-block">
                            <NavLink to="/login" className="nav-link"><FontAwesomeIcon icon={faSignOutAlt} /> Log Out</NavLink >
                        </li>
                    </ul>
                   
                </nav>
            </div>
        )
    }
}

export default Header